import axios from 'axios';
import apiRequestHeaders from '../apiRequestHeaders';
import { invoiceFilter } from '../../features/invoicing/invoicesSlice';

export interface ImportOpenBalanceResponse {
  jobId: string;
}

export interface ImportJobStatusResponse {
  jobId: string;
  status: string;
  processedCount: number;
  totalCount: number;
  matchedRows: number;
  unmatchedRows: number;
  progressPercentage: number;
  errorMessage?: string;
}

export function fetchInvoices(invoicegetFilter: invoiceFilter) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
  };
  return axios
    .post('/invoicing/invoicing/searchinvoices', invoicegetFilter, config)
    .then(res => {
      return res.data;
    });
}

export function exportInvoicesExcel(invoicesFilter: invoiceFilter) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
    responseType: 'blob' as const,
    timeout: 0,
  };
  return axios
    .post('/invoicing/invoicing/exportinvoicesexcel', invoicesFilter, config)
    .then(res => {
      const url = window.URL.createObjectURL(
        new Blob([res.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        }),
      );
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'Laskuarkisto.xlsx');
      link.click();
      link.remove();
      return res.data;
    });
}

export function recreateInvoicePdf(invoiceId: string, locale: string) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
  };
  return axios
    .post('/booking/bookings/recreateinvoicepdf', { invoiceId, locale }, config)
    .then(res => res.data);
}

export function getAvailableImportFiles() {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
  };
  return axios
    .get(
      '/invoicing/invoicing/getavailableimportfiles/availableimportfiles',
      config,
    )
    .then(res => res.data);
}

export function importOpenBalance(fileName?: string) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
  };
  return axios
    .post('/invoicing/invoicing/importopenbalance', { fileName }, config)
    .then(res => res.data);
}

export function getImportJobStatus(jobId: string) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
  };
  return axios
    .get(
      `/invoicing/invoicing/getimportjobstatus/importjobstatus?jobId=${jobId}`,
      config,
    )
    .then(res => res.data);
}
